import { createModalContext, useModalState } from '@/common/app/modal'
import { ChildProps } from '@/common/util/props'

import MediaAnalysisHelpModal from '@/components/container/modal/mediaAnalysis/MediaAnalysisHelpModal'

// isGeoLlmo=false: SEO分析（競合分析AI・GSC連携・SERP実データ・コンテンツギャップ・カニバリ・内部リンク）
// isGeoLlmo=true : GEO/LLMO分析（サイテーション・シェア・オブ・ボイス・センチメント・クエリファンアウト）
export interface MediaAnalysisHelpModalState {
  isGeoLlmo: boolean
}

const defaultValue: MediaAnalysisHelpModalState = { isGeoLlmo: false }

export const MediaAnalysisHelpModalContext =
  createModalContext<MediaAnalysisHelpModalState>(defaultValue)

const MediaAnalysisHelpModalProvider = ({ children }: ChildProps) => {
  const state = useModalState<MediaAnalysisHelpModalState>(defaultValue)
  return (
    <MediaAnalysisHelpModalContext.Provider value={state}>
      {children}
      <MediaAnalysisHelpModal />
    </MediaAnalysisHelpModalContext.Provider>
  )
}

export default MediaAnalysisHelpModalProvider
